module.exports = __webpack_public_path__ + "static/media/tecnologia.442ed904.svg";